export default __webpack_public_path__ + "7978d43a6a2f4a6df9173e78efe59677.svg";